import React from 'react';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { Theme, Typography } from 'web-library';

interface Props {
  remarks: string;
}

const useStyles = makeStyles()((theme) =>
({
  attachedFilesHeader: {
    color: theme.color.text.textHeader,
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1.5),
  },
  remarkStatement: {
    marginBottom: theme.spacing(0.5),
  },
}));

const UploadAdditionalDocumentsRemarks = (props: Props) => {
  const { t } = useTranslation();
  const { remarks } = props;

  const { classes } = useStyles();

  return (
    <>
      <Typography variant="body1" className={classes.attachedFilesHeader}>
        {t('exam->>NonNationalExam.Remarks')}
      </Typography>
      <Typography className={classes.remarkStatement} variant="body1">
        {remarks}
      </Typography>
    </>
  );
};

export default UploadAdditionalDocumentsRemarks;
